const ratingStorageKeys = {
    lastRatingDate: 'LAST_RATING_DATE',
    lastPaymentStatus: 'RATING_SUCCESS_INDICATOR',
};

type RateStatus = 'success' | 'none' | 'failure';

export const setRateModalStorage = ({
    lastRatingDate,
    lastPaymentStatus,
}: {
    lastPaymentStatus?: RateStatus;
    lastRatingDate?: Date;
}) => {
    if (lastPaymentStatus) {
        localStorage.setItem(
            ratingStorageKeys.lastPaymentStatus,
            lastPaymentStatus
        );
    }

    if (lastRatingDate) {
        localStorage.setItem(
            ratingStorageKeys.lastRatingDate,
            dayConfig.js(lastRatingDate).toISOString()
        );
    }
};

export const getRateModalStorage = () => {
    const lastPaymentStatus = localStorage.getItem(
        ratingStorageKeys.lastPaymentStatus
    ) as RateStatus;
    const lastRatingDate = localStorage.getItem(
        ratingStorageKeys.lastRatingDate
    );

    return {
        lastPaymentStatus,
        lastRatingDate: dayConfig.js(lastRatingDate),
    };
};
